import { inject, Injectable } from '@angular/core';
import { Title as BrowserTitle } from '@angular/platform-browser';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TitleService {
  private readonly browserTitle = inject(BrowserTitle);

  private readonly title$: BehaviorSubject<string>;

  public constructor() {
    this.title$ = new BehaviorSubject(this.browserTitle.getTitle());
  }

  public title(): Observable<string> {
    return this.title$.asObservable();
  }

  public setTitle(title: string): void {
    const applicationTitle = 'Pure Beauty';
    const browserTitle = `${applicationTitle} | ${title}`;

    this.browserTitle.setTitle(browserTitle);
    this.title$.next(title);
  }
}
